import BaseApi from '@/api/Base/BaseApi'
import {
  CreateModelRetrainNodeFromDqiPayload,
  CreateModelRetrainNodeFromModelDriftPayload,
  GetModelRetrainNodeDetailResponse,
  GetReferenceNodesPipelineInfoResponse,
  UpdateModelRetrainNodePayload,
  ModelRetrainExportPayload,
  ReplaceDriftReferencePayload,
  GetModelRetrainNodeListPayload
} from '@/api/ModelRetrainNode/types'
import { CommonListPayload } from '@/api/DatasetNode/types'
import { CommonValidationResult, GetValidationResultItemsResponse } from '@/api/ValidationNode/types'

const ROOT = '/model-retrain'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'asc',
  sortKey: 'datasetItemId',
}

export default class ModelRetrainNodeApi extends BaseApi {
  createModelRetrainNodeFromDqi(payload: CreateModelRetrainNodeFromDqiPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create`, rest)
  }

  createModelRetrainNodeFromModelDrift(payload: CreateModelRetrainNodeFromModelDriftPayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create/model-drift`, rest)
  }

  updateModelRetrainNode(payload: UpdateModelRetrainNodePayload) {
    const { modelRetrainNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainNodeId}`, { ...rest, name: name?.trim() })
  }

  exportModelRetrain(payload: ModelRetrainExportPayload) {
    const { modelRetrainNodeId, ...rest } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/export`, rest)
  }

  getModelRetrainNodeDetail(modelRetrainNodeId: string) {
    return this.agent.get<GetModelRetrainNodeDetailResponse>(`${ROOT}/${modelRetrainNodeId}`)
  }

  getReferenceNodesPipelineInfo(modelRetrainNodeId: string) {
    return this.agent.get<GetReferenceNodesPipelineInfoResponse>(`${ROOT}/${modelRetrainNodeId}/pipeline`)
  }

  replaceDriftReference(payload: ReplaceDriftReferencePayload) {
    const { modelRetrainNodeId } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/replace-drift-reference`)
  }

  getModelRetrainNodeList(payload: GetModelRetrainNodeListPayload) {
    const { projectId, ...rest } = payload
    return this.agent.get<GetModelRetrainNodeDetailResponse[]>(`project/${projectId}/model-retrain-list`, { params: rest })
  }

  getRetrainResultSummary(modelRetrainNodeId: string) {
    return this.agent.get<CommonValidationResult>(`${ROOT}/${modelRetrainNodeId}/summary`)
  }

  getRetrainResultItems(modelRetrainNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions
    return this.agent.get<GetValidationResultItemsResponse>(`${ROOT}/${modelRetrainNodeId}/result-items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  // downloadModelRetrain(payload: any) {
  //   const { aiJobId, ...rest } = payload
  //   return this.agent.post(`${ROOT}/${aiJobId}/download`, rest)
  // }
}
